import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
export default {
  name: "Mixin_RecordViews",
  mixins: [RecordViews],
  components: {},
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    //move to mixin
    ...mapGetters({
      user: "user/user",
      family: "user/family"
    }),
    iconImgProps() {
      if (this.resource.imgURL) {
        this.mainProps.src = this.resource.imgURL;
      }
      return this.mainProps;
    },
    resourceBlockToolName() {
      if (this.resource.name) {
        return this.resource.name;
      }
      return "Awesome App";
    },
    settingsSessionObj() {
      let filteredSession =
        this.settings &&
        this.settings.user &&
        this.settings.user.sessions &&
        Array.isArray(this.settings.user.sessions) &&
        this.sessionId
          ? this.settings.user.sessions.filter(aSessionName => {
              return aSessionName.sessionId == this.sessionId;
            })
          : null;
      return filteredSession &&
        Array.isArray(filteredSession) &&
        filteredSession.length > 0
        ? filteredSession[0]
        : null;
    }
  },
  beforeMount() {
    /* More than likely not neded
   this.settingsUser = this.settings && this.settings.user ? this.settings.user : {};
    //Toggle Set-Up - may be a a hack at the moment but this should work

    this.toggles.forEach( (aToggle) => {
      if (this.settingsUser.hasOwnProperty(aToggle.property)) {
        aToggle.value = this.settingsUser[aToggle.property];
      }
    });
    */
  },
  beforeDestroy() {
    this.stopPlaying();
  },
  methods: {
    /* AUDIO HANDLING*/
    playRepeat() {
      debugger;
      //move to top level Mixin
      if (this.playInd < this.playList.length) {
        //Just in case a new one is added or deleted during play
        //first insure that thye player is nulled out and not creating orphan players
        //move to clear the player
        this.playerCheckClear();

        const audioURL = this.playList[this.playInd];

        this.player = new Audio(audioURL);

        this.player.addEventListener("ended", p => {
          this.player.currentTimer = 0;
          this.playInd++; //If shuffle- then randomize
          this.playRepeat();
        });
        //this.audioDuration = this.getDuration(this.player.duration);
        if (this.player) {
          this.player.play();
        }
      } else {
        this.playInd = 0;
      }
    },
    playerCheckClear() {
      if (this.player) {
        // do any necessary cleanup
        this.player.pause();
        this.player = null;
      }
    },
    stopPlaying() {
      this.playerCheckClear();
    },
    getDuration(seconds) {
      let measuredTime = new Date(null);
      measuredTime.setSeconds(seconds); // specify value of SECONDS
      return measuredTime.toISOString().substr(11, 8);
    },
    /* EVENT TRACKING*/
    handleAppLog(data) {
      this.$emit("appLog", data);
    },
    /* ABOUT_INTRO */
    handleAboutClick() {
      debugger;
      this.$emit("user-clicked-about");
    },
    handleUpdateUserData(userDataPayload) {
      debugger; //Display
      this.$emit("update-user-data", userDataPayload);
    },
    /*FAMILY- HOOK FOR MYAPPS*/
    handleGetFamily() {
      //gets family for the user this app is for
      return new Promise((res, rej) => {
        this.$store
          .dispatch("user/getListFamily")
          .then(response => {
            res(response);
          })
          .catch(error => {
            rej(error);
          });
      });
    },
    getSessionObj() {
      debugger;
      let filteredSession =
        this.userData &&
        this.userData.sessions &&
        Array.isArray(this.userData.sessions) &&
        this.sessionId
          ? this.userData.sessions.filter(aSessionName => {
              return aSessionName.sessionId == this.sessionId;
            })
          : null;
      return filteredSession &&
        Array.isArray(filteredSession) &&
        filteredSession.length > 0
        ? filteredSession[0]
        : null;
    }
  },
  data() {
    return {
      sessionId: this.checkSession("sessions"),
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      assetsURLHome: "override",
      player: null,
      playInd: 0,
      playList: []
    };
  }
};
